import { InputGroup as InputComponent, InputGroupProps } from '@chakra-ui/input';
import { forwardRef } from '@chakra-ui/system';
import * as React from 'react';

export type IInputGroupProps = InputGroupProps;

export const InputGroup = forwardRef<IInputGroupProps, 'div'>(({ ...rest }, ref) => {
  return <InputComponent {...rest} ref={ref} />;
});
